import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "flex justify-between space-x-2 tw"
};
const _hoisted_2 = {
  class: "w-1/2"
};
const _hoisted_3 = {
  class: "w-6/12"
};
const _hoisted_4 = {
  class: "w-full flex gap-2"
};
const _hoisted_5 = {
  class: "w-6/12"
};
const _hoisted_6 = {
  class: "w-6/12 pt-8"
};
const _hoisted_7 = {
  class: "w-full flex gap-2",
  "data-replay-unmask": ""
};
const _hoisted_8 = {
  class: "w-6/12"
};
const _hoisted_9 = {
  class: "w-full flex gap-2"
};
const _hoisted_10 = {
  key: 0,
  class: "w-4/12"
};
const _hoisted_11 = {
  key: 1,
  class: "w-4/12"
};
const _hoisted_12 = {
  class: "w-full flex gap-2"
};
const _hoisted_13 = {
  key: 0,
  class: "w-4/12"
};
const _hoisted_14 = {
  key: 1,
  class: "w-4/12"
};
const _hoisted_15 = {
  key: 0,
  class: "w-6/12"
};
const _hoisted_16 = {
  class: "w-full flex gap-2"
};
const _hoisted_17 = {
  class: "w-6/12"
};
const _hoisted_18 = {
  class: "w-6/12"
};
const _hoisted_19 = {
  key: 2,
  class: "space-x-2 tw"
};
import { onMounted, onBeforeUnmount, reactive, computed } from 'vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { storeToRefs } from 'pinia';
import LlSelect from '@/components/LlSelect.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import CodePicker from '@/components/CodePicker.vue';
import LlTextField from '@/components/LlTextField.vue';
import SelectUser from '@/components/SelectUser.vue';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import DescriptionPreviewModal from './DescriptionPreviewModal.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCodeStore } from '@/services/useCodeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import RemoveLineItemModal from './modalception/RemoveLineItemModal.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { mod, round2, calculateEntryAmount } from '@/services/utils';
import { useEntryInitStore } from '@/services/useEntryInitStore';
import { useRateGroupLogic } from '@/composables/useRateGroupLogic';
import useClientMatterStore from '@/services/useClientMatterStore';
export default {
  __name: 'TimeEntryLineItem',
  emits: ['confirm', 'cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const invoiceState = useInvoiceState();
    const invoiceEditorStore = useInvoiceEditorStore();
    const codeStore = useCodeStore();
    const meStore = useMeStore();
    const {
      handleError,
      handleInfo
    } = useSnackbarHandler();
    const {
      permissions
    } = storeToRefs(useMeStore());
    const {
      selectedLineItem
    } = invoiceEditorStore;
    const {
      onlyViewInvoice,
      isSaving
    } = storeToRefs(useInvoiceEditorStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      removeLineItem
    } = invoiceState;
    const {
      getIsLocked
    } = useInvoiceState();
    const entryInitStore = useEntryInitStore();
    const {
      shouldFetchMatterDetails,
      fetchMatterDetailsIfNeeded,
      getRateListWithSelection
    } = useRateGroupLogic();
    const {
      getMatterByIdForEntryDropdown
    } = useClientMatterStore();
    const timeEntryModalState = reactive({
      me: {},
      availableAccounts: [],
      matterDetail: null,
      // Store complete matter details with users array, like EditEntry.vue
      form: {
        id: '',
        description: '',
        date: '',
        account: {},
        amount: '',
        creditNegative: '',
        includeCodes: false,
        showAccountTotals: false,
        includeHours: false,
        descriptionPreview: '',
        writedown: 0,
        hours: 0,
        worked: 0,
        step: 0,
        entries: [],
        rate: 0,
        codes: {
          activity: {
            id: null
          },
          task: {
            id: null
          }
        }
      },
      loaded: false,
      showRemoveLineModal: false,
      showErrors: false
    });

    // Modal instance counters to force fresh component creation
    const modalCounters = reactive({
      removeLine: 0
    });

    // Cleanup nested modal states on unmount to prevent overlay accumulation
    onBeforeUnmount(() => {
      timeEntryModalState.showRemoveLineModal = false;
      clearTimeout(amountChangeDebounceTimer);
    });
    onMounted(async () => {
      await codeStore.activityCodes();
      await codeStore.taskCodes();

      // Initialize step with company settings
      const localDefaultStep = companySettings.value.timeEntryIncrement || 0.1;
      entryInitStore.updateStep(localDefaultStep);
      timeEntryModalState.form = JSON.parse(JSON.stringify(selectedLineItem));
      if (timeEntryModalState.form.entries && timeEntryModalState.form.entries.length) {
        timeEntryModalState.form.entries.forEach(e => {
          e.step = companySettings.value.timeEntryIncrement || 0.1;
          // Derive writedown from hours and billedHours when not already set.
          // The backend only sends hours + billedHours; writedown is a frontend-only field.
          if (e.billingType === 'billable' && (e.writedown === undefined || e.writedown === null || e.writedown === 0)) {
            const h = parseFloat(e.hours) || 0;
            const bh = parseFloat(e.billedHours);
            if (!isNaN(bh) && h > bh) {
              e.writedown = round2(h - bh);
            }
          }
        });
        // Sync form-level writedown for multi-entry line items.
        // The template binds the disabled summary field to form.writedown (not the computed),
        // so it must be set explicitly after entry-level writedowns are derived.
        timeEntryModalState.form.writedown = writedown.value;
      }
      timeEntryModalState.form.step = companySettings.value.timeEntryIncrement || 0.1;
      if (invoiceState.ledes) {
        timeEntryModalState.form.codes = timeEntryModalState.form.codes || {
          activity: {
            id: null
          },
          task: {
            id: null
          }
        };
        timeEntryModalState.form.codes.activity = timeEntryModalState.form.codes.activity || {
          id: null
        };
        timeEntryModalState.form.codes.task = timeEntryModalState.form.codes.task || {
          id: null
        };
      }
      timeEntryModalState.me = meStore.me;

      // Ensure non-billable entries have zero rates and amounts
      if (timeEntryModalState.form.entries && timeEntryModalState.form.entries.length) {
        const allNonBillableEntries = timeEntryModalState.form.entries.every(entry => entry.billingType === 'nonBillable' || entry.billingType === 'fixedFee');
        if (allNonBillableEntries) {
          timeEntryModalState.form.rate = {
            amount: 0
          };
          timeEntryModalState.form.amount = 0;
          timeEntryModalState.form.entries.forEach(entry => {
            entry.rate = {
              amount: 0,
              edited: entry.rate?.edited || false
            };
          });
        }
      }

      // Fetch matter details if needed for rate group logic
      await fetchMatterUsers();

      // Note: User fetching and filtering is now handled by the SelectUser component
      timeEntryModalState.loaded = true;
    });
    const fetchMatterUsers = async () => {
      const matterId = invoiceState.getCurrentMatterId();
      if (matterId) {
        // Use the same endpoint as EditEntry.vue to get complete matter details with users array
        // This ensures matter-specific custom rates are available when Rate Groups are disabled
        timeEntryModalState.matterDetail = await getMatterByIdForEntryDropdown(matterId, true);

        // Also update invoiceState for compatibility with existing Draft Editor logic
        if (shouldFetchMatterDetails(invoiceState)) {
          await fetchMatterDetailsIfNeeded(matterId, invoiceState, handleError);
        }
      }
    };
    const handleCodeChange = event => {
      timeEntryModalState.form.codes = event;
    };
    const handleEntryHourChange = entry => {
      timeEntryModalState.form.worked = worked;
      timeEntryModalState.form.writedown = writedown;

      // Update step based on current hours using entryInitStore
      if (entry.hours) {
        entryInitStore.updateStep(entry.hours);
      }
      entry.billedHours = entry.hours - parseFloat(entry.writedown || 0);
      handleHourRateChange();
    };
    const handleHourRateChange = () => {
      timeEntryModalState.form.worked = worked;
      timeEntryModalState.form.writedown = writedown;
      timeEntryModalState.form.hours = round2(timeEntryModalState.form.worked - timeEntryModalState.form.writedown);
      const {
        hours,
        rate
      } = timeEntryModalState.form;

      // Update step based on current hours using entryInitStore
      if (hours) {
        entryInitStore.updateStep(hours);
      }

      // Skip rate/amount calculations for non-billable entries
      if (isNonBillableEntry.value) {
        timeEntryModalState.form.amount = 0;
        return;
      }
      timeEntryModalState.form.amount = calculateEntryAmount(rate.amount, hours);
    };
    const handleAmountChange = () => {
      // Skip calculations for non-billable entries
      if (isNonBillableEntry.value) {
        timeEntryModalState.form.amount = 0;
        return;
      }
      if (!timeEntryModalState.form.amount || timeEntryModalState.form.amount == '') timeEntryModalState.form.amount = 0;
      // Don't do this calculaton for expenses/ffs

      // if we have writedown enabled, write the entry down, otherwise adjust the rate
      const {
        amount,
        rate,
        hours
      } = timeEntryModalState.form;
      if (adjustments.value && rate.amount) {
        timeEntryModalState.form.writedown = writedown;
        timeEntryModalState.form.rate.amount = round2(amount / timeEntryModalState.form.hours);
        if (timeEntryModalState.form.writedown < 0) {
          timeEntryModalState.form.writedown = 0;
          timeEntryModalState.form.worked = timeEntryModalState.form.hours;
        }
      } else {
        rate.amount = round2(amount / timeEntryModalState.form.hours);
      }

      // Snap Amount to round2(Rate * Hours) now, rather than leaving the stored
      // Amount at a value its own displayed Rate can't reproduce - a later
      // recalc (Hours retype, Write down) would otherwise silently drift it by
      // a cent (sc-46770).
      if (hours) {
        const snapped = calculateEntryAmount(rate.amount, hours);
        timeEntryModalState.form.amount = snapped;
        // Compare in whole cents, not raw floats: `snapped - amount` on two
        // "clean" 2-decimal values (e.g. 812.45 - 812.44) can land a hair under
        // 0.01 from IEEE-754 subtraction error, silently skipping the toast for
        // a real 1-cent adjustment.
        if (Math.round(snapped * 100) !== Math.round(amount * 100)) {
          handleInfo(`Amount adjusted to $${snapped.toFixed(2)} to match rate × hours`);
        }
      }
    };

    // Debounced so the snap/toast above runs once, ~500ms after the user
    // pauses typing, rather than on every keystroke (sc-47546) - typing
    // mid-number no longer risks a snap rewriting the value out from under
    // the cursor.
    let amountChangeDebounceTimer;
    const debouncedHandleAmountChange = () => {
      clearTimeout(amountChangeDebounceTimer);
      amountChangeDebounceTimer = setTimeout(handleAmountChange, 500);
    };
    const worked = computed(() => {
      return timeEntryModalState.form.entries.reduce((accum, e) => parseFloat(accum) + (parseFloat(e.hours) || 0), 0);
    });
    const writedown = computed(() => {
      return timeEntryModalState.form.entries.reduce((accum, e) => parseFloat(accum) + (parseFloat(e.writedown) || 0), 0);
    });
    const customFlagLabel = computed(() => {
      return companySettings.value.labels?.customFlag || null;
    });

    // Check if the current line item contains only non-billable or fixed fee entries
    const isNonBillableEntry = computed(() => {
      if (!timeEntryModalState.form.entries || !timeEntryModalState.form.entries.length) {
        return false;
      }
      // If all entries are non-billable or fixed fee, hide rate/amount fields
      return timeEntryModalState.form.entries.every(entry => entry.billingType === 'nonBillable' || entry.billingType === 'fixedFee');
    });
    const confirm = () => {
      const entry = timeEntryModalState.form.entries[0];
      const workedHours = parseFloat(entry.hours || 0);
      const writeDown = parseFloat(entry.writedown || 0);
      if (workedHours <= 0) {
        handleError('Hours must be greater than zero');
        return;
      }

      // Skip write-down validation for non-billable entries
      if (!isNonBillableEntry.value) {
        if (writeDown < 0) {
          handleError('Write-down must be a positive value.');
          return;
        }
        if (writeDown > workedHours) {
          handleError('Write-down cannot exceed worked hours.');
          return;
        }
      }
      const increment = parseFloat(companySettings.value.timeEntryIncrement || 0.1);
      if (companySettings.value.enforceRounding && mod(workedHours, increment) !== 0) {
        handleError(`Your firm has Enforced Rounding enabled. Your Hours must be an increment of ${increment}.`);
        return;
      }

      // Skip amount validation for non-billable entries (they should always be 0)
      if (!isNonBillableEntry.value && timeEntryModalState.form.amount < 0) {
        handleError('Amount must be a positive value.');
        return;
      }
      timeEntryModalState.form.description = timeEntryModalState.form.descriptionPreview;

      // Only update rates for billable entries
      if (!isNonBillableEntry.value) {
        timeEntryModalState.form.entries.forEach(e => {
          e.rate = timeEntryModalState.form.rate;
        });
      } else {
        // Ensure non-billable entries maintain zero rate and amount
        timeEntryModalState.form.rate = {
          amount: 0
        };
        timeEntryModalState.form.amount = 0;
        timeEntryModalState.form.entries.forEach(e => {
          e.rate = {
            amount: 0
          };
        });
      }
      if (applyDisabled.value) {
        let message = timeEntryModalState.form.account === null ? 'User is required. ' : '';
        let emptyDescriptions = timeEntryModalState.form.entries.filter(e => e.description.length === 0);
        if (emptyDescriptions.length > 0) {
          message += 'Description is required.';
        }
        handleError(message);
      } else {
        invoiceState.updateLineItem(timeEntryModalState.form);
        emit('cancel');
      }
    };
    const removeLineModal = () => {
      timeEntryModalState.showRemoveLineModal = true;
    };
    const adjustments = computed(() => {
      return companySettings.value?.adjustments || false;
    });
    const removeEntry = entry => {
      if (timeEntryModalState.form.entries.length === 1) {
        removeOrDeleteLineItem();
      } else {
        let index = timeEntryModalState.form.lineItems.indexOf(x => x.id === entry.id);
        if (index > -1) {
          timeEntryModalState.form.lineItem.entries.splice(index, 1);
        }
        timeEntryModalState.form.status = 'updated'; //updated
      }
    };
    const removeOrDeleteLineItem = ({
      action
    }) => {
      if (action) {
        timeEntryModalState.form.status = action;
        if (action === 'savedForLater') {
          timeEntryModalState.form.entries.forEach(e => {
            e.billed = false;
            e.timeSheetId = null;
          });
        }
      }
      removeLineItem(timeEntryModalState.form);
      emit('cancel');
    };
    const applyDisabled = computed(() => {
      return timeEntryModalState.form.account === null || timeEntryModalState.form.entries.filter(e => e.description.length === 0).length > 0 || rateError.value;
    });
    const handleAccountChange = () => {
      const lineItemAccount = timeEntryModalState.form.account;

      // Preserve all user properties without modifying the name
      // The description generation logic elsewhere should use (initials || name)
      // but we shouldn't modify the name property itself to avoid dropdown display issues
      const accountToSave = {
        ...lineItemAccount
        // Keep name as the full name for display purposes
        // Keep initials separate for description generation
      };
      timeEntryModalState.form.account = accountToSave;
      timeEntryModalState.form.entries.forEach(entry => {
        entry.account = accountToSave;
      });

      // For non-billable, don't update rates or amounts
      if (isNonBillableEntry.value) {
        // Ensure rates and amounts remain zero for non-billable entries
        timeEntryModalState.form.rate = {
          amount: 0
        };
        timeEntryModalState.form.amount = 0;
        timeEntryModalState.form.entries.forEach(entry => {
          entry.rate = {
            amount: 0
          };
        });
        return;
      }

      // Update rate when timekeeper changes using proper rate group logic
      // Use matterDetail from TimeEntryLineItem state (like EditEntry.vue does)
      // Fall back to invoiceState.matter for compatibility
      const matter = timeEntryModalState.matterDetail || invoiceState.matter || (invoiceState.matters && invoiceState.matters.length > 0 ? invoiceState.matters[0] : null);
      if (!matter || !accountToSave) {
        return;
      }

      // This will check for Rate Group, Matter-specific, then Standard rates
      // Now using the same parameters as EditEntry.vue adjustRateToSelection function
      const {
        selectedRate
      } = getRateListWithSelection(accountToSave, matter, true,
      // isExistingEntry - we're editing an existing entry
      timeEntryModalState.form,
      // existingForm
      false,
      // isMatterChange - matter doesn't change in edit flow
      true,
      // isUserChange - user just changed!
      false,
      // isDuplicate
      null,
      // originalEntry
      false // matterChangedDuringSession
      );
      if (selectedRate) {
        timeEntryModalState.form.rate = selectedRate;
        // Update all entries with the new rate
        timeEntryModalState.form.entries.forEach(entry => {
          entry.rate = selectedRate;
        });
        // Recalculate amount based on new rate
        handleHourRateChange();
      }
    };
    const handleDateChange = () => {
      const lineItemDate = new Date(timeEntryModalState.form.date);

      // dateChanged will trigger a re-sort when we save
      timeEntryModalState.form.dateChanged = !invoiceEditorStore.sameDate(lineItemDate, selectedLineItem.date);
      timeEntryModalState.form.entries.forEach(entry => {
        let startDate = new Date(entry.startTime);
        startDate.setDate(lineItemDate.getDate());
        startDate.setMonth(lineItemDate.getMonth());
        startDate.setFullYear(lineItemDate.getFullYear());
        entry.startTime = startDate;
        let endDate = entry.startTime.getTime() + entry.hours * 60 * 60 * 1000;
        entry.endTime = new Date(endDate);
      });
    };
    const rateError = computed(() => {
      // Non-billable and Fixed Fee entries don't need rates
      if (isNonBillableEntry.value) {
        return false;
      }
      const rate = timeEntryModalState.form.rate?.amount;
      return rate === null || rate === undefined || rate === '';
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("Edit line item entry", -1)]))]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_component_v_dialog, {
            modelValue: timeEntryModalState.showRemoveLineModal,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => timeEntryModalState.showRemoveLineModal = $event), _cache[3] || (_cache[3] = val => val && modalCounters.removeLine++)],
            width: "400",
            attach: '#draft-modal-container',
            scrim: "true",
            persistent: "",
            key: `time-entry-remove-line-${modalCounters.removeLine}`
          }, {
            default: _withCtx(() => [_createVNode(RemoveLineItemModal, {
              typeLabel: "This Time Entry",
              adjustOption: adjustments.value,
              onCancel: _cache[1] || (_cache[1] = $event => timeEntryModalState.showRemoveLineModal = false),
              onConfirm: removeOrDeleteLineItem
            }, null, 8, ["adjustOption"])]),
            _: 1
          }, 8, ["modelValue"])), !timeEntryModalState.loaded ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: 0,
            type: "card,table-row-divider,table-row"
          })) : _createCommentVNode("", true), timeEntryModalState.loaded ? (_openBlock(), _createBlock(DescriptionPreviewModal, {
            key: 1,
            "line-item": timeEntryModalState.form,
            me: timeEntryModalState.me,
            onRemoveEntry: removeEntry,
            onUpdateHours: handleEntryHourChange,
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
          }, null, 8, ["line-item", "me", "disabled"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(SelectUser, {
            modelValue: timeEntryModalState.form.account,
            "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => timeEntryModalState.form.account = $event), handleAccountChange],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving) || !_unref(permissions)?.billing?.edit,
            "use-matter-filtering": true,
            "matter-id": _unref(invoiceState).getCurrentMatterId()
          }, null, 8, ["modelValue", "disabled", "matter-id"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlDatePicker, {
            "data-cy": "line-item-date",
            modelValue: timeEntryModalState.form.date,
            "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => timeEntryModalState.form.date = $event), _cache[6] || (_cache[6] = $event => handleDateChange())],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
          }, null, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_6, [customFlagLabel.value ? (_openBlock(), _createBlock(LlCheckbox, {
            key: 0,
            modelValue: timeEntryModalState.form.customFlag,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => timeEntryModalState.form.customFlag = $event),
            label: customFlagLabel.value,
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)
          }, null, 8, ["modelValue", "label", "disabled"])) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("label", {
            class: _normalizeClass(adjustments.value && !isNonBillableEntry.value ? 'w-4/12' : 'w-6/12')
          }, " Hours Worked", 2), adjustments.value && !isNonBillableEntry.value ? (_openBlock(), _createElementBlock("label", _hoisted_10, " Write down")) : _createCommentVNode("", true), adjustments.value && !isNonBillableEntry.value ? (_openBlock(), _createElementBlock("label", _hoisted_11, " Hours Billed")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
            class: _normalizeClass(adjustments.value && !isNonBillableEntry.value ? 'w-4/12' : 'w-6/12')
          }, [timeEntryModalState.form.entries.length > 1 ? (_openBlock(), _createBlock(LlTextField, {
            key: 0,
            density: "compact",
            variant: "outlined",
            modelValue: worked.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => worked.value = $event),
            disabled: "true",
            type: "number"
          }, null, 8, ["modelValue"])) : _createCommentVNode("", true), timeEntryModalState.form.entries.length === 1 ? (_openBlock(), _createBlock(LlTextField, {
            key: 1,
            "data-cy": "hours-worked-input",
            density: "compact",
            variant: "outlined",
            modelValue: timeEntryModalState.form.entries[0].hours,
            "onUpdate:modelValue": [_cache[9] || (_cache[9] = $event => timeEntryModalState.form.entries[0].hours = $event), _cache[10] || (_cache[10] = $event => handleEntryHourChange(timeEntryModalState.form.entries[0]))],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving),
            type: "number",
            step: _unref(entryInitStore).localStep,
            min: 0,
            rules: [() => !!timeEntryModalState.form.entries[0].hours || 'This field is required', () => timeEntryModalState.form.entries[0].hours >= 0 || 'Must be greater than 0']
          }, null, 8, ["modelValue", "disabled", "step", "rules"])) : _createCommentVNode("", true)], 2), adjustments.value && !isNonBillableEntry.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [timeEntryModalState.form.entries.length > 1 ? (_openBlock(), _createBlock(LlTextField, {
            key: 0,
            density: "compact",
            variant: "outlined",
            disabled: "true",
            modelValue: timeEntryModalState.form.writedown,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => timeEntryModalState.form.writedown = $event),
            type: "number",
            placeholder: "0.0"
          }, null, 8, ["modelValue"])) : _createCommentVNode("", true), timeEntryModalState.form.entries.length === 1 ? (_openBlock(), _createBlock(LlTextField, {
            key: 1,
            "data-cy": "write-down-input",
            density: "compact",
            variant: "outlined",
            modelValue: timeEntryModalState.form.entries[0].writedown,
            "onUpdate:modelValue": [_cache[12] || (_cache[12] = $event => timeEntryModalState.form.entries[0].writedown = $event), _cache[13] || (_cache[13] = $event => handleEntryHourChange(timeEntryModalState.form.entries[0]))],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving),
            type: "number",
            placeholder: "0.0",
            step: _unref(companySettings).timeEntryIncrement || 0.1
          }, null, 8, ["modelValue", "disabled", "step"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), adjustments.value && !isNonBillableEntry.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(LlTextField, {
            "data-cy": "hours-billed-input",
            density: "compact",
            variant: "outlined",
            disabled: "true",
            modelValue: timeEntryModalState.form.hours,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => timeEntryModalState.form.hours = $event)
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)])]), !isNonBillableEntry.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(LlTextField, {
            "data-cy": "rate-input",
            label: "Rate",
            density: "compact",
            variant: "outlined",
            modelValue: timeEntryModalState.form.rate.amount,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => timeEntryModalState.form.rate.amount = $event),
            type: 'number',
            onChange: _cache[16] || (_cache[16] = $event => handleHourRateChange()),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving),
            rules: [v => v !== null && v !== undefined && v !== '' || `User's rate cannot be left blank`],
            hideDetails: false
          }, null, 8, ["modelValue", "disabled", "rules"])]), _createElementVNode("div", _hoisted_18, [_createVNode(LlTextField, {
            "data-cy": "amount-input",
            label: "Amount",
            density: "compact",
            variant: "outlined",
            modelValue: timeEntryModalState.form.amount,
            "onUpdate:modelValue": [_cache[17] || (_cache[17] = $event => timeEntryModalState.form.amount = $event), _cache[18] || (_cache[18] = $event => debouncedHandleAmountChange())],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving),
            type: "number"
          }, null, 8, ["modelValue", "disabled"])])])])) : _createCommentVNode("", true)]), _unref(invoiceState).ledes && timeEntryModalState.loaded ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(CodePicker, {
            form: timeEntryModalState.form,
            disabled: _unref(getIsLocked) || _unref(isSaving) || _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit,
            onCodeChange: handleCodeChange,
            "data-cy": "time-entry-line-item-code-picker"
          }, null, 8, ["form", "disabled"])])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            class: "w-100"
          }, {
            prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
              class: "mr-2",
              onBtnClick: _cache[19] || (_cache[19] = $event => _ctx.$emit('cancel'))
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getIsLocked) || _unref(isSaving) || _unref(onlyViewInvoice) ? 'Close' : 'Cancel'), 1)]),
              _: 1
            }), !(_unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              class: "ml-2",
              onBtnClick: _cache[20] || (_cache[20] = $event => removeLineModal())
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode(" Remove ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            append: _withCtx(() => [!(_unref(onlyViewInvoice) || _unref(getIsLocked) || _unref(isSaving)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              disabled: applyDisabled.value,
              color: "primary",
              variant: "flat",
              onBtnClick: _cache[21] || (_cache[21] = $event => confirm()),
              "data-cy": "edit-draft-apply-button"
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" Apply ", -1)]))]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};